import TextContent from "../TextContent";
import AudioContent from "../AudioContent";
import styles from "./audioTextStyles.module.scss";

export default function AudioTextCard(props) {
  const { data } = props;

  return (
    <div className={styles.maket}>
      <AudioContent data={data} icon={false} />
      <TextContent data={data} lefty />
    </div>
  );
}
